const {abstractResource} = require('./abstractResource')

const service = abstractResource('HUMAN_RESOURCES')

const AbsenceDocument = {...service('absence-documents')}
const HolidayParam = {
    ...service('holiday-params'),

    get_form() {
        return {
            business_days_per_week: null,
            holidays_by_reference_period: null,
            first_month_reference_cycle: null,
            is_available_on_same_period: false,
            holidays_duration_cycle_amount: null,
            holidays_duration_cycle_unit: null,
            period: null,
        }
    },
    get_business_days_per_week_choices() {
        return [
            { text: 'Jours ouvrés', value:  5},
            { text: 'Jours ouvrables', value: 6 },
        ]
    },
    get_first_month_reference_cycle_choices() {
        return [
            { text: 'Janvier - Décembre ', value: 1 },
            { text: 'Février - Janvier', value: 2 },
            { text: 'Mars - Février', value: 3 },
            { text: 'Avril - Mars', value: 4 },
            { text: 'Mai - Avril', value: 5 },
            { text: 'Juin - Mai', value: 6 },
            { text: 'Juillet - Juin', value: 7 },
            { text: 'Août - Juillet', value: 8 },
            { text: 'Septembre - Août', value: 9 },
            { text: 'Octobre - Septembre', value: 10 },
            { text: 'Novembre - Octobre', value: 11 },
            { text: 'Décembre - Novembre', value: 12 },
        ]
    },
    get_is_available_on_same_period_choices() {
        return [
            { text: 'Dans le cycle actuel', value: true },
            { text: 'Dans le cycle suivant', value: false },
        ]
    },
    get_holidays_duration_cycle_amount_choices() {
        return [
            { text: '1 mois après la fin du cycle', value: 'one_month' },
            { text: '2 mois après la fin du cycle', value: 'two_month' },
            { text: '3 mois après la fin du cycle', value: 'three_month' },
            { text: '4 mois après la fin du cycle', value: 'four_month' },
            { text: '5 mois après la fin du cycle', value: 'five_month' },
            { text: '6 mois après la fin du cycle', value: 'six_month' },
            { text: '7 mois après la fin du cycle', value: 'seven_month' },
            { text: '8 mois après la fin du cycle', value: 'eight_month' },
            { text: '9 mois après la fin du cycle', value: 'nine_month' },
            { text: '10 mois après la fin du cycle', value: 'ten_month' },
            { text: '11 mois après la fin du cycle', value: 'eleven_month' },
        ]
    },
    get_holidays_duration_cycle_unit_choices() {
        return [
            { text: 'Après 1 cycle complets', value: 'one_cycle' },
            { text: 'Après 2 cycle complets', value: 'two_cycle' },
            { text: 'Après 3 cycle complets', value: 'three_cycle' },
        ]
    },
}
const AbsenceType = {
    ...service('absence-types'),

    get_form() {
        return {
            name: null,
            is_deducted_from_holiday_balance: false,
            is_requiring_validation: false,
            is_equivalent_working_day: false,
            need_justificative_documents: 'no',
            holiday_param: null,
        }
    },

    get_name_choices(){
      return [
          {text: 'Deuil', value: 'Bereavement',},
          {text: 'Arrêt de travail pour garde d’enfant (COVID-19)', value: 'Childcare leave (COVID-19)',},
          {text: 'Repos compensateur', value: 'Compensatory rest',},
          {text: 'Congés pour création d’entreprise', value: 'Leave for business creation',},
          {text: 'Congés pour enfant malade', value: 'Leave for sick child',},
          {text: 'Congés maternité', value: 'Maternity leave',},
          {text: 'Congés payés', value: 'Paid leave',},
          {text: 'Congé parental d’éducation', value: 'Parental leave for education',},
          {text: 'Congés paternité', value: 'Paternity leave',},
          {text: 'Congés sabbatiques', value: 'Sabbatical leave',},
          {text: 'Congés d’ancienneté', value: 'Seniority leave',},
          {text: 'Arrêt maladie', value: 'Sick leave',},
          {text: 'Arrêt de travail simplifié (COVID-19)', value: 'Simplified work stoppage (COVID-19)',},
          {text: 'Jours de fractionnement', value: 'Split days',},
          {text: 'Télétravail', value: 'Telecommuting',},
          {text: 'RTT', value: 'Time off',},
          {text: 'Compte Épargne Temps', value: 'Time Savings Account',},
          {text: 'Formation', value: 'Training',},
          {text: 'Déplacement', value: 'Travel',},
          {text: 'Congés sans solde', value: 'Unpaid leave',},
      ]
    },

    get_is_deducted_from_holiday_balance_choices() {
        return [
            { text: "Oui", value: true },
            { text: "Non", value: false },
        ]
    },
    get_is_requiring_validation_choices() {
        return [
            { text: 'Oui', value: true },
            { text: 'Non', value: false },
        ]
    },
    get_is_equivalent_working_day_choices() {
        return [
            { text: 'Oui', value: true },
            { text: 'Non', value: false },
        ]
    },
    get_need_justificative_documents_choices() {
        return [
            { text: 'Oui, facultatif', value: 'yes_optional' },
            { text: 'Oui, obligatoire', value: 'yes_required' },
            { text: 'Non', value: 'no' },
        ]
    },
    get_type_choices() {
        return [
            { value: 'granted', text: 'Validé' },
            { value: 'cancelled', text: 'Annulé' },
            { value: 'denied', text: 'Refusé' },
            { value: 'waiting', text: 'En attente' },
        ]
    },
}

const Absence = {
    ...service('absences'),
    get_form() {
        return {
            employee_comment: null,
            employee: null,
            absence_type: null,
            start_date: null,
            end_date: null,
            half_day: null,
        }
    },
    get_status_choices() {
        return [
            { value: 'granted', text: 'Validé' },
            { value: 'cancelled', text: 'Annulé' },
            { value: 'denied', text: 'Refusé' },
            { value: 'waiting', text: 'En attente' },
        ]
    },
    get_half_day_choices() {
        return [
            { value: 'first half', text: 'Matin' },
            { value: 'second half', text: 'Après-midi' },
        ]
    },
    get_status_color() {
        return {
            cancelled: 'info',
            denied: 'danger',
            waiting: 'warning',
            granted: 'success',
        }
    },
    cancel(id, { data = {}, ...axiosConfig } = {}) {
        return this.request({ method: 'POST', url: this.url + id + '/cancel/', data, ...axiosConfig })
    },
    validated(id, { data = {}, ...axiosConfig } = {}) {
        return this.request({ method: 'POST', url: this.url + id + '/validate/', data, ...axiosConfig })
    },
    overlaps( { params= {}, ...axiosConfig } = {}) {
        return this.get({ params, url: this.url +'overlaps/', ...axiosConfig })
    },
}


const Activity = {...service('activities')}
const Amount = {...service('amounts')}
const AnnouncementComment = {...service('announcement-comments')}
const Announcement = {...service('announcements')}
const Approval = {...service('approvals')}
const CompanyGoodType = {
    ...service('company-good-types'),
    get_form() {
        return {
            name: null,
        }
    }
}
const CompanyGood = {
    ...service('company-goods'),
    get_form() {
        return {
            name: null,
            type:null,
            start_date:null,
            end_date:null,
            trial_period_start_date:null,
            start_reason:null,
            prior_notice_period:null,
            trial_unit:null,
            trial_period:null,
            prior_notice_unit:null,
            end_reason:null,
            employee_type:null,
            professional_status:null,
            classification:null,
            qualification:null,
            rate:null,
            id_cost_center:null,
            cost_center_rate:null,
            contract_status:null,
            coefficient:null,
            employee:null,
        }
    }
}
const Contract = {
    ...service('contracts'),

    get_form() {
        return {
            type: null,
            start_date: null,
            end_date: null,
            trial_period_start_date: null,
            start_reason: null,
            prior_notice_period: null,
            prior_notice_unit: null,
            end_reason: null,
            employee_type: null,
            professional_status: null,
            classification: null,
            rate: null,
            id_cost_center: null,
            cost_center_rate: null,
            employee: null,
            trial_unit: null,
            trial_period: null,
        }
    },
    get_contract_choice() {
        return [
            {value: 'cdi', text: 'Contrat à durée indéterminée (CDI)'},
            {value: 'cdd', text: 'Contrat à durée déterminée (CDD)'},
            {value: 'mission', text: 'Contrat de travail temporaire (mission)'},
            {value: 'cdichantier', text: 'CDI de chantier'},
            {value: 'apprenticeshipcontract', text: 'Contrat d’apprentissage'},
            {value: 'youthemploymentcontract', text: 'Contrat emploi jeune'},
            {value: 'internshipagreement', text: 'Convention de stage'},
            {value: 'professionalizationcontract', text: 'Contrat de professionnalisation'},
            {value: 'secondmentcontract', text: 'Contrat détaché'},
            {value: 'nocontract', text: 'Sans contrat'},
            {value: 'other', text: 'Autre'},
        ]
    },

    get_start_reason() {
        return [
            {value: 'hiring', text: 'Embauche'},
            {value: 'transfer', text: 'Mutation'},
            {value: 'replacement', text: 'Remplacement'},
            {value: 'internship', text: 'Stage'},
            {value: 'extraworkload', text: 'Surcroît d’activité'},
            {value: 'other', text: 'Autre'},
        ]
    },

    get_end_reason() {
        return [
            {value: 'resignation', text: 'Démission'},
            {value: 'endofafixed-termcontract', text: 'Fin de CDD'},
            {value: 'endoftrialperiod(employer)', text: 'Fin de période d’essai (à l’initiative de l’employeur)'},
            {value: 'endoftrialperiod(employee)', text: 'Fin de période d’essai (à l’initiative du salarié)'},
            {value: 'terminationbyagreement', text: 'Rupture conventionnelle'},
            {value: 'economicdismissal', text: 'Licenciement économique'},
            {value: 'redundancy(other)', text: 'Licenciement (autre)'},
            {value: 'retirement(leave)', text: 'Mise à la retraite'},
            {value: 'retirement(departure)', text: 'Départ à la retraite'},
            {value: 'endofcontract', text: 'Fin de contrat'},
            {value: 'endofinternship', text: 'Fin de stage'},
            {value: 'earlyterminationoffixed-termcontractbymutualagreement', text: 'Rupture anticipée de CDD par commun accord'},
            {value: 'other', text: 'Autre'},
        ]
    },

    get_prior_notice() {
        return [
            {value: 'days', text: 'Jours'},
            {value: 'months', text: 'Mois'}]
    },

    get_employee_type() {
        return [
            {value: 'permanentemployee', text: 'Salarié permanent'},
            {value: 'minoremployee', text: 'Salarié mineur'},
            {value: 'minijob', text: 'Mini job'},
            {value: 'internship', text: 'Stage'},
            {value: 'studentemployee', text: 'Étudiant salarié'},
        ]
    },

    get_professional_status() {
        return [
            {value: 'leader', text: 'Dirigeant'},
            {value: 'executive', text: 'Cadre'},
            {value: 'non-executive', text: 'Non cadre'},
            {value: 'worker', text: 'Ouvrier'},
            {value: 'employee', text: 'Employé'},
            {value: 'technician', text: 'Technicien'},
            {value: 'supervisor', text: 'Agent de maîtrise'},
            {value: 'trainee', text: 'Stagiaire'},
            {value: 'apprentice', text: 'Apprenti'},
            {value: 'other', text: 'Autre'},
            {value: 'autonomous executive', text: 'Cadre autonome'},
            {value: 'ETAM', text: 'ETAM'},]
    },
    get_contract_status() {
        return [
            {value: "in-progress", text: "En cours"},
            {value: "end", text: "Terminée"},
        ]
    },

}
const Customer = {...service('customers')}
const DayWeek = {
    ...service('day-weeks'),
    get_form() {
        return {
            day_week_number: null,
            time_slot_1_start: '09:00',
            time_slot_1_end: '12:00',
            time_slot_2_start: '13:00',
            time_slot_2_end: '17:00',
            is_time_slot_1_active: true,
            is_time_slot_2_active: true,
            is_active: true,
            schedule_template: null,
        }
    },
    get_day_week_choices() {
        return [
            {value: 0, text: "Lundi"},
            {value: 1, text: "Mardi"},
            {value: 2, text: "Mercredi"},
            {value: 3, text: "Jeudi"},
            {value: 4, text: "Vendredi"},
            {value: 5, text: "Samedi"},
            {value: 6, text: "Dimanche"},
        ]
    },
    get_default_week() {
        const value = []
        for (let i = 0; i < 7; i++) {
            value.push(DayWeek.get_form())
            value[i].day_week_number = i
            value[i].is_time_slot_1_active = false
            value[i].is_time_slot_2_active = false
            value[i].is_active = false
        }
        return value
    },
}
const Department = {
    ...service('departments'),
    get_form() {
        return {
            name: null,
            employee: null,
        }
    }
}
        const Dependant = {
    ...service('dependants'),

    get_form() {
        return {
            last_name: null, first_name: null, civility: null, date_of_birth: null, relationship: null, employee: null
        }
    },

    get_gender_choices() {
        return [
            {value: 'various', text: 'Divers'},
            {value: 'male', text: 'Homme'},
            {value: 'woman', text: 'Femme'},
            {value: 'undefined', text: 'Indéfini'},
            {value: 'unknown', text: 'Inconnu'},
        ];
    },

    get_relationship_choices() {
        return [
            {value: 'child', text: 'Enfant'},
            {value: 'parent', text: 'Parent'},
            {value: 'other', text: 'Autre'},]
    }
}
const EmployeeLanguage = {...service('employee-languages')}
const EmployeeTask = {...service('employee-tasks')}
const Employee = {
    ...service('employees'),
    get_form() {
        return {
            employee_type: null,
            employee_id: null,
            date_first_entry: null,
            last_name: null,
            first_name: null,
            birth_name: null,
            professional_email: null,
            professional_phone: null,
            personal_email: null,
            personal_phone: null,
            date_of_birth: null,
            country_of_birth: null,
            department_of_birth: null,
            nationality: null,
            civility: null,
            address_1: null,
            address_2: null,
            city: null,
            zip_code: null,
            department: null,
            emergency_contact_name: null,
            emergency_contact_phone: null,
            linkedin_url: null,
            facebook_url: null,
            twitter_url: null,
            social_security_id: null,
            profile_photo: null,
            profile_description: null,
            country: null,
            marital_status: null,
            id_employee:null,
        }
    },
    get_employee_type() {
        return [
            {value: 'permanent', text: 'Salarié permanent'},
            {value: 'temporaire', text: 'Salarié temporaire'},
        ]
    },
    get_country_choices() {
        return [
            {value: "AF", text: "Afghanistan"},
            {value: "AX", text: "Åland Islands"},
            {value: "AL", text: "Albania"},
            {value: "DZ", text: "Algeria"}, {value: "AS", text: "American Samoa"},
            {value: "AD", text: "Andorra"},
            {value: "AO", text: "Angola"},
            {value: "AI", text: "Anguilla"},
            {value: "AQ", text: "Antarctica"},
            {value: "AG", text: "Antigua and Barbuda"},
            {value: "AR", text: "Argentina"}, {value: "AM", text: "Armenia"},
            {value: "AW", text: "Aruba"},
            {value: "AU", text: "Australia"},
            {value: "AT", text: "Austria"},
            {value: "AZ", text: "Azerbaijan"},
            {value: "BS", text: "Bahamas"},
            {value: "BH", text: "Bahrain"},
            {value: "BD", text: "Bangladesh"},
            {value: "BB", text: "Barbados"},
            {value: "BY", text: "Belarus"},
            {value: "BE", text: "Belgium"},
            {value: "BZ", text: "Belize"},
            {value: "BJ", text: "Benin"},
            {value: "BM", text: "Bermuda"},
            {value: "BT", text: "Bhutan"},
            {value: "BO", text: "Bolivia (Plurinational State of)"},
            {value: "BQ", text: "Bonaire, Sint Eustatius and Saba"},
            {value: "BA", text: "Bosnia and Herzegovina"},
            {value: "BW", text: "Botswana"}, {value: "BV", text: "Bouvet Island"},
            {value: "BR", text: "Brazil"},
            {value: "IO", text: "British Indian Ocean Territory"},
            {value: "BN", text: "Brunei Darussalam"},
            {value: "BG", text: "Bulgaria"},
            {value: "BF", text: "Burkina Faso"},
            {value: "BI", text: "Burundi"},
            {value: "CV", text: "Cabo Verde"},
            {value: "KH", text: "Cambodia"},
            {value: "CM", text: "Cameroon"},
            {value: "CA", text: "Canada"},
            {value: "KY", text: "Cayman Islands"},
            {value: "CF", text: "Central African Republic"},
            {value: "TD", text: "Chad"},
            {value: "CL", text: "Chile"},
            {value: "CN", text: "China"},
            {value: "CX", text: "Christmas Island"},
            {value: "CC", text: "Cocos (Keeling) Islands"},
            {value: "CO", text: "Colombia"},
            {value: "KM", text: "Comoros"},
            {value: "CG", text: "Congo"},
            {value: "CD", text: "Congo (the Democratic Republic of the)"},
            {value: "CK", text: "Cook Islands"},
            {value: "CR", text: "Costa Rica"},
            {value: "CI", text: "Côte d'Ivoire"},
            {value: "HR", text: "Croatia"},
            {value: "CU", text: "Cuba"},
            {value: "CW", text: "Curaçao"},
            {value: "CY", text: "Cyprus"},
            {value: "CZ", text: "Czechia"},
            {value: "DK", text: "Denmark"},
            {value: "DJ", text: "Djibouti"},
            {value: "DM", text: "Dominica"},
            {value: "DO", text: "Dominican Republic"},
            {value: "EC", text: "Ecuador"},
            {value: "EG", text: "Egypt"},
            {value: "SV", text: "El Salvador"},
            {value: "GQ", text: "Equatorial Guinea"},
            {value: "ER", text: "Eritrea"},
            {value: "EE", text: "Estonia"},
            {value: "SZ", text: "Eswatini"},
            {value: "ET", text: "Ethiopia"},
            {value: "FK", text: "Falkland Islands (Malvinas)"},
            {value: "FO", text: "Faroe Islands"},
            {value: "FJ", text: "Fiji"},
            {value: "FI", text: "Finland"},
            {value: "FR", text: "France"},
            {value: "GF", text: "French Guiana"},
            {value: "PF", text: "French Polynesia"},
            {value: "TF", text: "French Southern Territories"},
            {value: "GA", text: "Gabon"},
            {value: "GM", text: "Gambia"},
            {value: "GE", text: "Georgia"},
            {value: "DE", text: "Germany"},
            {value: "GH", text: "Ghana"},
            {value: "GI", text: "Gibraltar"},
            {value: "GR", text: "Greece"},
            {value: "GL", text: "Greenland"},
            {value: "GD", text: "Grenada"},
            {value: "GP", text: "Guadeloupe"},
            {value: "GU", text: "Guam"},
            {value: "GT", text: "Guatemala"},
            {value: "GG", text: "Guernsey"},
            {value: "GN", text: "Guinea"},
            {value: "GW", text: "Guinea-Bissau"},
            {value: "GY", text: "Guyana"},
            {value: "HT", text: "Haiti"},
            {value: "HM", text: "Heard Island and McDonald Islands"},
            {value: "VA", text: "Holy See"},
            {value: "HN", text: "Honduras"},
            {value: "HK", text: "Hong Kong"},
            {value: "HU", text: "Hungary"},
            {value: "IS", text: "Iceland"},
            {value: "IN", text: "India"},
            {value: "ID", text: "Indonesia"},
            {value: "IR", text: "Iran (Islamic Republic of)"},
            {value: "IQ", text: "Iraq"},
            {value: "IE", text: "Ireland"},
            {value: "IM", text: "Isle of Man"},
            {value: "IL", text: "Israel"},
            {value: "IT", text: "Italy"},
            {value: "JM", text: "Jamaica"},
            {value: "JP", text: "Japan"},
            {value: "JE", text: "Jersey"},
            {value: "JO", text: "Jordan"},
            {value: "KZ", text: "Kazakhstan"},
            {value: "KE", text: "Kenya"},
            {value: "KI", text: "Kiribati"},
            {value: "KP", text: "Korea (the Democratic People's Republic of)"},
            {value: "KR", text: "Korea (the Republic of)"},
            {value: "KW", text: "Kuwait"},
            {value: "KG", text: "Kyrgyzstan"},
            {value: "LA", text: "Lao People's Democratic Republic"},
            {value: "LV", text: "Latvia"},
            {value: "LB", text: "Lebanon"},
            {value: "LS", text: "Lesotho"},
            {value: "LR", text: "Liberia"},
            {value: "LY", text: "Libya"},
            {value: "LI", text: "Liechtenstein"},
            {value: "LT", text: "Lithuania"},
            {value: "LU", text: "Luxembourg"},
            {value: "MO", text: "Macao"},
            {value: "MG", text: "Madagascar"},
            {value: "MW", text: "Malawi"},
            {value: "MY", text: "Malaysia"},
            {value: "MV", text: "Maldives"},
            {value: "ML", text: "Mali"},
            {value: "MT", text: "Malta"},
            {value: "MH", text: "Marshall Islands"},
            {value: "MQ", text: "Martinique"},
            {value: "MR", text: "Mauritania"},
            {value: "MU", text: "Mauritius"},
            {value: "YT", text: "Mayotte"},
            {value: "MX", text: "Mexico"},
            {value: "FM", text: "Micronesia (Federated States of)"},
            {value: "MD", text: "Moldova (the Republic of)"},
            {value: "MC", text: "Monaco"},
            {value: "MN", text: "Mongolia"},
            {value: "ME", text: "Montenegro"},
            {value: "MS", text: "Montserrat"},
            {value: "MA", text: "Morocco"},
            {value: "MZ", text: "Mozambique"},
            {value: "MM", text: "Myanmar"},
            {value: "NA", text: "Namibia"},
            {value: "NR", text: "Nauru"},
            {value: "NP", text: "Nepal"},
            {value: "NL", text: "Netherlands"},
            {value: "NC", text: "New Caledonia"},
            {value: "NZ", text: "New Zealand"},
            {value: "NI", text: "Nicaragua"},
            {value: "NE", text: "Niger"},
            {value: "NG", text: "Nigeria"},
            {value: "NU", text: "Niue"},
            {value: "NF", text: "Norfolk Island"},
            {value: "MK", text: "North Macedonia"},
            {value: "MP", text: "Northern Mariana Islands"},
            {value: "NO", text: "Norway"}, {value: "OM", text: "Oman"},
            {value: "PK", text: "Pakistan"}, {value: "PW", text: "Palau"},
            {value: "PS", text: "Palestine, State of"},
            {value: "PA", text: "Panama"},
            {value: "PG", text: "Papua New Guinea"},
            {value: "PY", text: "Paraguay"},
            {value: "PE", text: "Peru"},
            {value: "PH", text: "Philippines"},
            {value: "PN", text: "Pitcairn"},
            {value: "PL", text: "Poland"},
            {value: "PT", text: "Portugal"},
            {value: "PR", text: "Puerto Rico"},
            {value: "QA", text: "Qatar"},
            {value: "RE", text: "Réunion"},
            {value: "RO", text: "Romania"},
            {value: "RU", text: "Russian Federation"},
            {value: "RW", text: "Rwanda"},
            {value: "BL", text: "Saint Barthélemy"},
            {value: "SH", text: "Saint Helena, Ascension and Tristan da Cunha"},
            {value: "KN", text: "Saint Kitts and Nevis"},
            {value: "LC", text: "Saint Lucia"},
            {value: "MF", text: "Saint Martin (French part)"},
            {value: "PM", text: "Saint Pierre and Miquelon"},
            {value: "VC", text: "Saint Vincent and the Grenadines"},
            {value: "WS", text: "Samoa"},
            {value: "SM", text: "San Marino"},
            {value: "ST", text: "Sao Tome and Principe"},
            {value: "SA", text: "Saudi Arabia"},
            {value: "SN", text: "Senegal"},
            {value: "RS", text: "Serbia"},
            {value: "SC", text: "Seychelles"},
            {value: "SL", text: "Sierra Leone"},
            {value: "SG", text: "Singapore"},
            {value: "SX", text: "Sint Maarten {Dutch part}"},
            {value: "SK", text: "Slovakia"},
            {value: "SI", text: "Slovenia"},
            {value: "SB", text: "Solomon Islands"},
            {value: "SO", text: "Somalia"},
            {value: "ZA", text: "South Africa"},
            {value: "GS", text: "South Georgia and the South Sandwich Islands"},
            {value: "SS", text: "South Sudan"},
            {value: "ES", text: "Spain"},
            {value: "LK", text: "Sri Lanka"},
            {value: "SD", text: "Sudan"},
            {value: "SR", text: "Suriname"},
            {value: "SJ", text: "Svalbard and Jan Mayen"},
            {value: "SE", text: "Sweden"},
            {value: "CH", text: "Switzerland"},
            {value: "SY", text: "Syrian Arab Republic"},
            {value: "TW", text: "Taiwan (Province of China)"},
            {value: "TJ", text: "Tajikistan"},
            {value: "TZ", text: "Tanzania, the United Republic of"},
            {value: "TH", text: "Thailand"},
            {value: "TL", text: "Timor-Leste"},
            {value: "TG", text: "Togo"},
            {value: "TK", text: "Tokelau"},
            {value: "TO", text: "Tonga"},
            {value: "TT", text: "Trinidad and Tobago"},
            {value: "TN", text: "Tunisia"},
            {value: "TR", text: "Turkey"},
            {value: "TM", text: "Turkmenistan"},
            {value: "TC", text: "Turks and Caicos Islands"},
            {value: "TV", text: "Tuvalu"},
            {value: "UG", text: "Uganda"},
            {value: "UA", text: "Ukraine"},
            {value: "AE", text: "United Arab Emirates"},
            {value: "GB", text: "United Kingdom of Great Britain and Northern Ireland"},
            {value: "UM", text: "United States Minor Outlying Islands"},
            {value: "US", text: "United States of America"},
            {value: "UY", text: "Uruguay"},
            {value: "UZ", text: "Uzbekistan"},
            {value: "VU", text: "Vanuatu"},
            {value: "VE", text: "Venezuela (Bolivarian Republic of)"},
            {value: "VN", text: "Viet Nam"},
            {value: "VG", text: "Virgin Islands (British)"},
            {value: "VI", text: "Virgin Islands (U.S.)"},
            {value: "WF", text: "Wallis and Futuna"},
            {value: "EH", text: "Western Sahara"},
            {value: "YE", text: "Yemen"},
            {value: "ZM", text: "Zambia"},
            {value: "ZW", text: "Zimbabwe"},

        ]
    },

    get_gender_choices() {
        return [
            {value: 'various', text: 'Divers'},
            {value: 'male', text: 'Homme'},
            {value: 'woman', text: 'Femme'},
            {value: 'non', text: 'Indéfini'},
            {value: 'unknown', text: 'Inconnu'},
        ];
    },
    get_employee_status() {
        return [
            {value: 'internal', text: 'Interne'},
            {value: 'external', text: 'Externe'},
        ]
    },

    get_status_choices(){
        return [
        {value: 'activ', text: 'Actif'},
        {value: 'onboarding', text: 'Onboarding'},
        {value: 'crossboarding', text: 'Crossboarding'},
        // {value: 'offbording', text: 'Offboarding'},
        ]
    },

    get_marital_status() {
        return [
            {value: 'concubine(e)', text: 'Concubin(e)'},
            {value: 'married', text: 'Marié(e)'},
            {value: 'divorced', text: 'Divorcé(e)'},
            {value: 'separated', text: 'Séparé(e)'},
            {value: 'common-law', text: 'Union libre'},
            {value: 'widow(er)', text: 'Veuf(ve)'},
            {value: 'civilunion', text: 'Pacsé(e)'},
            {value: 'singleparent', text: 'Parent isolé'},
            {value: 'notknown', text: 'Non connue'},
        ]
    }
}
const Evaluation = {
    ...service('evaluations'),
    get_form(){
        return{
            external_assessor_mail: null,
            employee: null,
            evaluator_employees: [],
            manager: null,
            feedback: null,
            is_closed: false,
            deadline: null,
        }
    },
}
const EventComment = {...service('event-comments')}
const Event = {...service('events')}
const ExpenseCategory = {...service('expense-categories')}
const ExpenseReport = {
    ...service('expense-reports'),
    form: {
        type: null,
        date: null,
        is_chargeable: false,
        gross_amount: 0,
        expense_report: null,
        expense_category: null,
        client: null,
    },

    get_form() {
        return {
            status: 'pending',
            name: null,
            employee: null,
            start_date: null,
            end_date: null,
            reference_number: 0,
        }
    },

    get_status_choices() {
        return [
            {value: 'granted', text: 'Validée', color: 'success'},
            {value: 'denied', text: 'Refusée', color: 'danger'},
            {value: 'refunded', text: 'Remboursée', color: ''},
            {value: 'cancelled', text: 'Annulée', color: 'secondary'},
            {value: 'waiting', text: 'En attente', color: 'warning'},
            {value: 'pending', text: 'En cours', color: 'tertiary'}
        ]
    },

    get_vehicle_type() {
        return [
            {text: '1 CV', value: '1'},
            {text: '2 CV', value: '2'},
            {text: '3 CV', value: '3'},
            {text: '4 CV', value: '4'},
            {text: '5 CV', value: '5'},
            {text: '6 CV', value: '6'},
            {text: '7 CV', value: '7'},
            {text: '8 CV', value: '8'},
            {text: '9 CV', value: '9'},
            {text: '10 CV', value: '10'},
            {text: '11 CV', value: '11'},
            {text: '12 CV', value: '12'},
            {text: '13 et + CV', value: '13+'},
        ]
    },

    get_type_choices() {
        return [
            {value: 'ExpenseTypeMiscellaneous', obj: ExpenseTypeMiscellaneous, text: 'Divers', icon: 'bx bx-dollar-circle'},
            {value: 'ExpenseTypeHotel', obj: ExpenseTypeHotel, text: 'Hôtel', icon: 'mdi mdi-bed'},
            {value: 'ExpenseTypeFurniture', obj: ExpenseTypeFurniture, text: 'Petit équipement / Fournitures', icon: 'bx bx-pencil'},
            {value: 'ExpenseTypeAdvance', obj: ExpenseTypeAdvance, text: 'Avance sur frais', icon: 'mdi mdi-calendar-clock'},
            {value: 'ExpenseTypeMobilePhone', obj: ExpenseTypeMobilePhone, text: 'Téléphone portable', icon: 'mdi mdi-cellphone'},
            {value: 'ExpenseTypeLunchRestaurant', obj: ExpenseTypeLunchRestaurant, text: 'Restaurant midi', icon: 'mdi mdi-silverware-variant'},
            {value: 'ExpenseTypeDinnerRestaurant', obj: ExpenseTypeDinnerRestaurant, text: 'Restaurant soir', icon: 'mdi mdi-silverware-variant'},
            {value: 'ExpenseTypePlane', obj: ExpenseTypePlane, text: 'Avion', icon: 'mdi mdi-airplane-takeoff'},
            {value: 'ExpenseTypeTrain', obj: ExpenseTypeTrain, text: 'Train', icon: 'mdi mdi-train'},
            {value: 'ExpenseTypeTaxi', obj: ExpenseTypeTaxi, text: 'Taxi', icon: 'mdi mdi-taxi'},
            {value: 'ExpenseTypeToll', obj: ExpenseTypeToll, text: 'Péage', icon: 'mdi mdi-road-variant'},
            {value: 'ExpenseTypeParking', obj: ExpenseTypeParking, text: 'Parking', icon: 'mdi mdi-parking'},
            {value: 'ExpenseTypePublicTransportation', obj: ExpenseTypePublicTransportation, text: 'Métro, bus', icon: 'mdi mdi-bus'},
            {value: 'ExpenseTypeDiesel', obj: ExpenseTypeDiesel, text: 'Carburant (essence)', icon: 'mdi mdi-gas-station'},
            {value: 'ExpenseTypeGasoline', obj: ExpenseTypeGasoline, text: 'Carburant (gazole)', icon: 'mdi mdi-gas-station'},
            {value: 'ExpenseTypeMileage', obj: ExpenseTypeMileage, text: 'Frais kilométrique', icon: 'mdi mdi-car'},
        ]
    },
}
const ExpenseTypeAdvance = {
  ...service('expense-type-advances'),
  form: {
    ...ExpenseReport.form,
    type: 'ExpenseTypeAdvance',
  },
  get_form() {
      return this.form
  }
}
const ExpenseTypeBase = {...service('expense-type-bases')}
const ExpenseTypeDiesel = {
    ...service('expense-type-diesels'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
        type: 'ExpenseTypeDiesel',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeDinnerRestaurant = {
    ...service('expense-type-dinner-restaurants'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
      intermediate_tax_amount: 0,
      reduced_tax_amount: 0,
      type: 'ExpenseTypeDinnerRestaurant',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeFurniture = {
  ...service('expense-type-furnitures'),
  form: {
    ...ExpenseReport.form,
    regular_tax_amount: 0,
    type: 'ExpenseTypeFurniture',
  },
  get_form() {
      return this.form
  }
}
const ExpenseTypeGasoline = {
  ...service('expense-type-gasolines'),
  form: {
    ...ExpenseReport.form,
    type: 'ExpenseTypeGasoline',
  },
  get_form() {
      return this.form
  }
}
const ExpenseTypeHotel = {
    ...service('expense-type-hotels'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
      intermediate_tax_amount: 0,
      reduced_tax_amount: 0,
      type: 'ExpenseTypeHotel',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeLunchRestaurant = {
    ...service('expense-type-lunch-restaurants'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
      intermediate_tax_amount: 0,
      reduced_tax_amount: 0,
      type: 'ExpenseTypeLunchRestaurant',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeMileage = {
    ...service('expense-type-mileages'),
    form: {
      ...ExpenseReport.form,
      start_location: null,
      end_location: null,
      is_round_trip: false,
      distance: 0,
      vehicle: null,
      type: 'ExpenseTypeMileage',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeMiscellaneous = {
  ...service('expense-type-miscellaneouss'),
  form: {
    ...ExpenseReport.form,
    regular_tax_amount: 0,
    intermediate_tax_amount: 0,
    type: 'ExpenseTypeMiscellaneous',
  },
  get_form() {
      return this.form
  }
}
const ExpenseTypeMobilePhone = {
    ...service('expense-type-mobile-phones'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
      intermediate_tax_amount: 0,
      type: 'ExpenseTypeMobilePhone',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeParking = {
    ...service('expense-type-parkings'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
      type: 'ExpenseTypeParking',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypePlane = {
    ...service('expense-type-planes'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
      type: 'ExpenseTypePlane',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypePublicTransportation = {
    ...service('expense-type-public-transportations'),
    form: {
      ...ExpenseReport.form,
      type: 'ExpenseTypePublicTransportation',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeTaxi = {
    ...service('expense-type-taxis'),
    form: {
      ...ExpenseReport.form,
      type: 'ExpenseTypeTaxi',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeToll = {
    ...service('expense-type-tolls'),
    form: {
      ...ExpenseReport.form,
      regular_tax_amount: 0,
      type: 'ExpenseTypeToll',
    },
    get_form() {
        return this.form
    }
}
const ExpenseTypeTrain = {
    ...service('expense-type-trains'),
    form: {
      ...ExpenseReport.form,
      type: 'ExpenseTypeTrain',
    },
    get_form() {
        return this.form
    }
}
const Expense = {...service('expenses')}
const Expertise = {
    ...service('expertises'),
    get_form() {
        return {
            names: [],
            positions: [],
        }
    },
}
const ExportHistory = {...service('export-histories')}
const ExtraBenefit = {...service('extra-benefits')}
const FeedbackAnswer = {
    ...service('feedback-answers'),

    get_grade_choices() {
        return [
            {value:0, text:"Ne souhaite pas répondre"},
            {value:1, text:"Tout à fait d’accord"},
            {value:2, text:"Plutôt d’accord"},
            {value:3, text:"Ni d’accord, ni pas d’accord"},
            {value:4, text:"Plutôt pas d’accord"},
            {value:5, text:"Pas d’accord"},
        ]
    },

}
const FeedbackQuestion = {
    ...service('feedback-questions'),

    get_form() {
        return {
        name:null,
        number:null,
    }
    },
}
const FeedbackStep = {...service('feedback-steps')}
const Feedback = {
    ...service('feedbacks'),

    get_status_choices() {
        return [
            {value: 'to_do', text: 'À faire'},
            {value: 'expires_soon', text: 'Expire bientôt'},
            {value: 'completed', text: 'Terminé'},
            {value: 'in_progress', text: 'En cours'},
            {value: 'closed', text: 'Clos'},
            {value: 'expired', text: 'Expiré'},]
    },

    duplicate(id, {data = {}, ...axiosConfig} = {}) {
        return this.request({method: 'POST', url: this.url + id + '/duplicate/', data, ...axiosConfig})
    },
}
const Flexibility = {...service('flexibilities')}
const GraduatedAnswer = {
    ...service('graduated-answers'),

    get_graduation_choices() {
        return [
            {value: 'insufficient', text: 'Insuffisant'},
            {value: 'satisfying', text: 'Satisfaisant'},
            {value: 'sufficient', text: 'Suffisant'},
            {value: 'very-satisfying', text: 'Très satisfaisant'},
        ]
    }
}
const HRDocument = {
    ...service('hr-documents'),
    get_form() {
        return {
            is_employee_document: false,
            details: null, employee: false,
            onboarding_task: null,
        }
    },
}
const HRNote = {...service('hr-notes')}
const InterviewCampaign = {
    ...service('interview-campaigns'),
    get_form() {
        return {
            name: null,
            start_date: null,
            end_date: null,
            departments: [],
            departmentChoices: [],
            teams: {},
            teamChoices: {},
            positions: {},
            manager: null,
            interview_type: null,
        }
    },
    get_form_slider(){
        return {
            full_name:null,
            date:null,
            hours:null,
            minutes:null,
            place:null,
        }
    },
    get_status_choices() {
        return [
            // {value: null, text: 'Please select an option'},
            {value: 'to_come', text: 'En attente'},
            {value: 'active', text: 'Date confirmée'},
            {value: 'ended', text: 'Réalisé'},
        ]
    },
    create_interviews(id) {
        return this.request({method: 'POST', url: this.url + id + '/create_interviews/'})
    },
}
const InterviewComment = {
    ...service('interview-comments'),
    get_type_choice() {
        return [
            {value: 'feedback', text: 'Feedback'},
            {value: 'comment', text: 'Commentaire'},
        ]
    },

}
const InterviewQuestion = {...service("interview-questions")};
const InterviewStep = {...service("interview-steps")};
const InterviewType = {
    ...service("interview-types"), get_form() {
        return {
            name: null,
            is_active: null,
            authorize_manager: null,
            has_objectives: null,
            hours: null,
            minutes: null,
        };
    },

    get_recurrence_choices() {
        return [
            {value:"weekly",text: "Hebdomadaire"},
            {value:"biweekly ",text: "Bihebdomadaire"},
            {value:"monthly", text:"Mensuel"},
            {value:"bimonthly",text: "Bimensuel"},
            {value:"quarterly", text:"Trimestriel"},
            {value:"annual",text: "Annuel"},
        ]
    }
};
const Interview = {
    ...service("interviews"),

    get_status_choices() {
        return [
            {value:"pending", text:'En attente'},
            {value:"planned", text:'Planifié'},
            {value:"ended", text:'Réalisé'},
        ]
    }
};

const Language = {...service('languages')}
const MailTemplate = {
    ...service('mail-templates'),
    get_form() {
        return {
            name: null,
            is_active: null,
            authorize_manager: null,
            has_objectives: null,
            hours: null,
            minutes: null,
        };
    },


}

const Objective = {
    ...service('objectives'),
    get_form() {
        return {
        name:null,
        value:null,
        result:null,
        interview:null,
        reviewed_date:null,}
    },
    get_status_choice() {
        return [
            {value: 'not_reached', text: 'Non atteint'},
            {value: 'reached', text: 'Atteint'},
            {value: 'exceeded', text: 'Dépassé'},
        ]
    },
}
const OnboardingComment = {...service('onboarding-comments')}
const OnboardingArticle = {
    ...service('onboarding-articles'),

}
const OnboardingStep = {
    ...service('onboarding-steps'),
    get_form() {
        return {
            name: null,
            onboarding: null,
            email_auto: false,
            email_template: null,
            number: 0,
            need_interview: false,
            period_amount: null,
            period_unit: null,
            is_automated: false,
        }
    },
    get_period_choice() {
        return [
            {value: 'months', text: 'mois'},
            {value: 'weeks', text: 'semaines'},
            {value: 'days', text: 'jours'},
            {value: 'hours', text: 'heures'},
        ]
    },
}
const OnboardingTask = {
    ...service('onboarding-tasks'),
    get_form() {
        return {
            onboarding_step: null,
            name: null,
            type: null,
            is_done: false,
            done_date: null,
            description: null,
            period_amount: null,
            period_unit: null,
            category: 'organization',
            role: 'boardee',
            priority: 'weak',
            h_r_documents: [],
            number: 0,
        }
    },
    get_role_choice() {
        return [
            {value: 'hr', text: 'RH'},
            {value: 'boardee', text: 'Boardee'},
            {value: 'manager', text: 'Manager'},
            {value: 'buddy', text: 'Buddy'},
        ]
    },
    get_actor_choice() {
        return [
            {value: 'onboardee', text: 'Onboardee'},
            {value: 'crossboardee', text: 'Crossboardee'},
            {value: 'offboardee', text: 'Offboardee'},
        ]
    },
    get_boardee() {
        return {
            onboarding: 'onboardee',
            crossboarding: 'crossboardee',
            offboarding: 'offboardee',
        }
    },
    get_employee_role() {
        return {
            HR: 'supervisor',
            crossboarding: 'crossboardee',
            offboarding: 'offboardee',
        }
    },
    get_category_choice() {
        return [
            {value: 'organization', text: 'Organisation'},
            {value: 'administrative', text: 'Administratif'},
            {value: 'information', text: 'Information'},
        ]
    },
    get_priority_choice() {
        return [
            {value: 'weak', text: 'Priorité faible'},
            {value: 'medium', text: 'Priorité moyenne'},
            {value: 'strong', text: 'Priorité forte'},
        ]
    },
    get_period_choice() {
        return [
            {value: 'days', text: 'jours'},
            {value: 'hours', text: 'heures'},
            {value: 'minutes', text: 'minutes'},
        ]
    },
}
const Onboarding = {
    ...service('onboardings'),
    MAX_STEPS: 7,
    duplicate(id, {data = {}, ...axiosConfig} = {}) {
        return this.request({method: 'POST', url: this.url + id + '/duplicate/', data, ...axiosConfig})
    },
    get_type_choice() {
        return [
            {value: 'onboarding', text: 'Onboarding'},
            {value: 'crossboarding', text: 'Crossboarding'},
            {value: 'offboarding', text: 'Offboarding'},
        ]
    },
    get_model_choice() {
        return [
            {value: 'new', text: 'Ajouter un nouveau modèle'},
            {value: 'existing', text: 'Nouveau pipeline'},
        ]
    },
    get_form() {
        return {
            onboarding_steps: [],
            name: null,
            type: null,
            is_template: false,
            is_protected: false,
            employee: null,
        }
    },
    get_status_choice() {
        return [
            {value: 'in_progress', text: 'En cours'},
            {value: 'overdue', text: 'En retard'},
            {value: 'waiting', text: 'En attente'},
            {value: 'completed', text: 'Terminé'},
        ]
    },
    get_color_status() {
        return {
            in_progress: 'primary',
            overdue: 'danger',
            waiting: 'warning',
            completed: 'success',
        }
    },
    get_color_type() {
        return {
            onboarding: 'primary',
            crossboarding: 'warning',
            offboarding: 'danger',
        }
    },
}
const OvertimeRuleWorkingSchedule = {
    ...service('overtime-rule-working-schedules'),
}
const OvertimeRule = {
  ...service('overtime-rules'),
  get_form() {
      return {
          type: null,
          description: null,
          pay_conversion_rate: 0,
          rest_conversion: false,
          rest_conversion_rate: 0,
          day_week_number: null,
          day: null,
          begin_time: null,
          end_time: null,
          time_interval: null,
          after_time: null,
          between_slot_1_time: null,
          between_slot_2_time: null,
          manager: null,
          employee: null,
      }
  },
}
const Participant = {...service('participants')}
const PayDetail = {
    ...service('pay-details'),

    get_form() {
        return {

            withholding_tax_percentage: null,
            is_eligible_half_day_meal_tickets: null,
            meal_tickets: null,
            payment_method: null,
            pay_roll_frequency: null,
            complementary_insurance_type: null,
            complementary_insurance_package: null,
            base_gross_salary_frequency: null,
            base_gross_salary_amount: null,
            contract: null,
            application_meal_tickets: null,
            advantages: null,
            complementary_insurance_name: null,
            insurance_name: null,
            social_security_number: null,
            expense_report:null,
        }
    },
    get_frequency_choice() {
        return [
            {value: "annual", text: "Annuel"},
            {value: "monthly", text: "Mensuel"},
            {value: "weekly", text: "Hebdomadaire"},
            {value: "daily", text: "Quotidien"},
            {value: "hourly", text: "Horaire"},
        ]
    },
    get_payment_methods() {
        return [
            {value: "cash", text: "Espèces"},
            {value: "check", text: "Chèque"},
            {value: "transfer", text: "Virement"},
            {value: "other", text: "Autre"},
        ]
    },

    get_complementary_insurance_type_choices() {
        return [
            {value: "public", text: "Publique"},
            {value: "private", text: "Privée"},
        ]
    },
}
const PayElement = {
    ...service('pay-elements'), get_form() {
        return {
            description: null,
            frequency: null,
            first_payment_date: null,
            base_amount: null,
            start_date: null,
            end_date: null,
            type: null,
            pay_detail: null,
        }
    },
    get_frequency_choices() {
        return [
            {value: "monthly", text: "Tous les mois"},
            {value: "bi-monthly", text: "Tous les 2 mois"},
            {value: "quarterly", text: "Tous les trimestres"},
            {value: "annual", text: "Tous les ans"},]
    },
    get_amount_type_choices() {
        return [
            {value: "fix", text: "Fixe"},
            {value: "undefined", text: "Non défini"},
            {value: "until", text: "Jusqu\'à"}
        ]
    }
}
const AccountCard = {
  ...service('account-cards'),

  get_form() {
      return {
          account_iban: null,
          account_bic: null,
          bank_name: null,
      }
  },
}
const PayRollBatch = {
  ...service('pay-roll-batchs'),

  get_form() {
    return {
      name: null,
      start_date: null,
      end_date: null,
      filters: null,
      is_repeated: false,
      recurrence_rule: null,
      validator: null,
      offboarding_only: false,
      status: 'todo',
    }
  },

  get_status_choices() {
    return [
      {text: 'À faire', value: 'todo', color: 'primary'},
      {text: 'En attente de validation', value: 'waiting', color: 'warning'},
      {text: 'Validé', value: 'validated', color: 'success'},
      {text: 'Partagé', value: 'shared', color: 'secondary'},
      {text: 'Terminé', value: 'done', color: 'success'},
    ]
  },

  get_rule_choices() {
    return [
      {text: 'Tous les jours', value: 'day'},
      {text: 'Toutes les semaines', value: 'week'},
      {text: 'Tous les mois', value: 'month'},
      {text: 'Tous les années', value: 'year'},
    ]
  },
  get_offboarding_only_choices() {
    return [
        { text: "Oui", value: true },
        { text: "Non", value: false },
    ]
  },
}
const PayRoll = {
    ...service('payrolls'),
    get_form() {
        return {
            start_date: null,
            end_date: null,
            contract: null,
            pay_roll_batch: null,
            commentary: null,
            department: null,
            team: null,
            position: null,
            paid_leave: null,
            time_off: null,
            sick_leave: null,
            other_leave: null,
            worked_hours: null,
            overtime_125_hours: null,
            overtime_150_hours: null,
            overtime_200_hours: null,
            gross_salary: null,
            transport: null,
            complementary_insurance_package: null,
            max_length: null,
            meal_tickets: null,
            target_bonus: null,
            exceptional_bonus: null,
            on_call_payment: null,
            another_advantage: null,
            commission_advance: null,
            payday_advance: null,
        }
    }
}
const Position = {
    ...service('positions'),
    get_form() {
        return {
            name: null,
        }
    },
}
const PositionContract = {
    ...service('position-contracts'),
    get_form() {
        return {
            is_principal: null,
            position: null,
            contract: null,
            manager: null,
            upper_hierarchy: null,
            job_status: null,
            job_name: null,
            status: null,
            employee: null,
            team: null,
            department: null,
        }
    },
    get_status() {
        return [
            {value: 'inactive', text: 'Inactif'},
            {value: 'holiday', text: 'Congé'},
            {value: 'activ', text: 'Actif'},
            {value: 'onboarding', text: 'Onboarding'},]
    },
    get_job_status() {
        return [
            {value: 'main', text: 'Principal'},
            {value: 'secondary', text: 'Secondaire'},
        ]
    },
}
const ProfessionalPaymentMethod = {
    ...service('professional-payment-methods'),

    get_form() {
        return {
            name: null,
            card_number: null,
            third_party_account: null,
            third_party_centralizing: null,
            is_active: null,
            is_company_card: null,
            contract: null,

        }
    }
}
const Project = {...service('projects')}
const Provider = {
    ...service('providers'),
    get_form() {
        return {
            name: null,
        }
    },
}
const PublicHoliday = {...service('public-holidays')}
const RentObject = {
    ...service('rent-objects'),

    get_form() {
        return {
            type_object: null,
            name: null,
            number: null,
        }
    }
}
const ReceiptDocument = {...service('receipt-documents')}
const RecurrenceRule = {...service('recurrence-rules')}
const ScheduleField = {...service('schedule-fields')}
const ScheduleTemplateWorkingSchedule = {
    ...service('schedule-template-working-schedules'),
}
const ScheduleTemplate = {
    ...service('schedule-templates'),

    get_form() {
        return {
            name: null,
            is_global: true,
        }
    }
}
const Schedule = {...service('schedules')}
const Session = {
    ...service('sessions'),
    get_form() {
        return {
            employees: [],
            end_date: null,
            location: null,
            max_participants: null,
            start_date: null,
            training_course: null,
        }
    },
}
const TaskActor = {...service('task-actors')}
const TaxRate = {...service('tax-rates')}
const Team = {
    ...service('teams'),
    get_form() {
        return {
            name: null,
            deparment: null,
            employee: null,
        }
    }
}
const TimeSheetConfig = {...service('timesheet-configs')}
const TimeSheetDetail = {
    ...service('timesheet-details'),

    get_form() {
        return {
            day_week_number: null,
            time_slot_1_start: null,
            time_slot_1_end: null,
            time_slot_2_start: null,
            time_slot_2_end: null,
            is_time_slot_1_active: true,
            is_time_slot_2_active: true,
            time_sheet_period: null,
        }
    }
}
const TimeSheetPeriod = {
    ...service('timesheet-periods'),

    get_form() {
        return {
            company: "1",
            time_sheet: null,
            is_sent: false,
            is_refused: false,
            is_accepted: false,
            week_number: 0,
            month: 0,
            year: 0,
        }
    },

    get_initial_period(periodView='week', month, year) {
        let timeSheetPeriod = {
            ...this.get_form(),
            time_sheet_details: [],
        }
        let periodDuration = 7
        let initialDay = 0
        if (periodView == 'month'){
            periodDuration = new Date(year, month + 1, 0).getDate()
            initialDay = (new Date(year, month, 1).getDay()-1)%7
            if(initialDay==-1) initialDay=6
        }
        console.log('initialDay', initialDay)
        for (let i = 0; i < periodDuration; i++) {
            timeSheetPeriod.time_sheet_details.push({
                ...TimeSheetDetail.get_form(),
                day_week_number: (i + initialDay)%7,
                month_week_number: Math.floor((i + initialDay) / 7),

            })
        }
        console.log(timeSheetPeriod.time_sheet_details)
        return timeSheetPeriod
    }
}

const TimeSheetPeriodStatus = {
    ...service('timesheet-period-statuses'),

    get_form() {
        return {
            time_sheet_period: null,
            status: null,
            description: null,
        }
    },

    get_status_choices(){
        return[
            {text: "En attente", value: "waiting"},
            {text: "Refusé", value: "refused"},
            {text: "Accepté", value: "accepted"},
        ]
    }
}

const TimeSheetProject = {
    ...service('timesheet-projects'),

    get_form() {
        return {
            project_name: null,
            project_id: null,
            time_sheet_period: null,
        }
    },

    get_initial_details() {
        let initialDetails = []
        for (let i = 0; i <= 6; i++) {
            initialDetails.push({
                ...TimeSheetProjectDetail.get_form(),
                day: i
            })
        }
        return initialDetails
    },
}

const TimeSheetProjectDetail = {
    ...service('timesheet-project-details'),

    get_form() {
        return {
            day: null,
            hours: 0,
            minutes: 0,
            is_active: false,
            time_sheet_project: null,
        }
    }
}
const TimeSheet = {...service('timesheets')}
const ValidationRule = {
    ...service('validation-rules'),

    get_form() {
        return {
            role: null,
            transfer: null,
            transfer_to: null,
            remark: null, responsible: null,
            employee: null,
        }
    },
    get_role_choice() {
        return [
            {value: "module_validation", text: "Validation de tous les modules"},
            {value: "leave_absence", text: "Validation congés et absences"},
            {value: "expense_report", text: "Validation notes de frais"},
            {value: "refund_expense_report", text: "Validation remboursement notes de frais"},
            {value: "time_activity", text: "Validation temps et activités"},]
    },
    get_transfer_choice() {
        return [
            {value: "unauthorized", text: "Non autorisé"},
            {value: "transfer_manual", text: "Transfert manuel"},
            {value: "transfer_automatic", text: "Transfert automatique"},
        ]
    }
}
const TrainingCourse = {
    ...service('training-courses'),
    get_form() {
        return {
            name: null,
            type: null,
            duration: null,
            individual_cost: null,
            group_cost: null,
            departments: [],
            teams: [],
            jobs: [],
            provider: null,
            archive: false,
            deadline: null,
            status: 'invisible',
        }
    },
    get_training_types_choices() {
        return [
            {text: 'Formation', value: 'training'},
            {text: 'Evolution/maintien dans l\'emploi/développement des compétences', value: 'evolution'},
            {text: 'Adaptation au poste', value: 'adaptation'},
            {text: 'Stage', value: 'internship'},
        ]
    },

    get_status_choices(){
        return[
            {text: 'Invisible', value: 'invisible'},
            {text: 'Non programmée', value: 'not_program'},
            {text: 'Programmée', value: 'program'},
            {text: 'Réalisée', value: 'realized'},
        ]
    },
}
const TrainingCoursePlan = {
    ...service('training-course-plans'),
    get_form() {
        return {
            employee: null,
            status: null,
            training_course: null,
        }
    },
    get_status_choices() {
        return [
            {text: 'En attente', value: 'pending'},
            {text: 'Accepté', value: 'accepted'},
            {text: 'Refusé', value: 'refuse'},
        ]
    }
}

const TrainingCourseInterest = {
    ...service('training-course-interests'),
    get_form() {
        return {
            employee: null,
            status: null,
            training_course: null,
        }
    },
    get_status_choices() {
        return [
            {text: 'En attente', value: 'pending'},
            {text: 'Accepté', value: 'accepted'},
            {text: 'Refusé', value: 'refuse'},
        ]
    }
}

const EmployeeSession = {
    ...service('employee-sessions'),
    get_form() {
        return {
            employee: null,
            status: null,
            session: null,
        }
    },
    get_status_choices() {
        return [
            {text: 'En attente', value: 'pending'},
            {text: 'Accepté', value: 'accepted'},
            {text: 'Refusé', value: 'refuse'},
        ]
    }
}
const VehicleFiscalHorsePower = {...service('vehicle-fiscal-horsepowers')}
const Vehicle = {
    ...service('vehicles'),

    get_form() {
        return {
            name: null,
            employee: null,
            fiscal_horsepower: null,
            brand: null,
            type: null,
            registration: null,
            car_registration_document: null,
            is_owned_by_company: false,
            id_company_gas_card: false,
            CO2_per_km: null,
            vehicle_fiscal_horse_power: null,
            already_exist_vehicle: false,
            new_vehicle: null,
            professional_vehicle: null,

        }
    },

    get_vehicle_type() {
        return [
            {value: "car 5CV", text: "auto 5CV"},
            {value: "moped", text: "cyclomoteur"},
            {value: "car", text: "automobile"},
            {value: "motorcycle", text: "moto"},
            {value: "commercial vehicles", text: "utilitaires"},
            {value: "cycle", text: "Vélo"},

        ]
    },
    get_fiscal_power() {
        return [
            {value: "1", text: "1 CV"},
            {value: "2", text: "2 CV"},
            {value: "3", text: "3 CV"},
            {value: "4", text: "4 CV"},
            {value: "5", text: "5 CV"},
            {value: "6", text: "6 CV"},
            {value: "7", text: "7 CV"},
            {value: "8", text: "8 CV"},
            {value: "9", text: "9 CV"},
            {value: "10", text: "10 CV"},
            {value: "11", text: "11 CV"},
            {value: "12", text: "12 CV"},
            {value: "13+", text: "13 et + CV"},

        ]
    }
}
const WorkingSchedule = {
  ...service('working-schedules'),

  get_form() {
      return {
        absence_leave: null,
        contract: null,
        days_by_year: null,
        hours_by_month: null,
        public_holiday: null,
        rtt: 0,
        time_modulation_type: null,
        timesheet: null,
        timesheet_validation_period: null,
        working_time: null,
      }
  },

  get_absence_leave_choices() {
      return [
          { value: 'base', text: 'DAYS congés payés', rtt: 0 },
          { value: 'learning', text: 'DAYS congés payés (apprentissage)', rtt: 0 },
          { value: '10', text: 'DAYS congés payés + 10 RTT', rtt: 10 },
          { value: '12', text: 'DAYS congés payés + 12 RTT', rtt: 12 },
          { value: '24', text: 'DAYS congés payés + 24 RTT', rtt: 24 },
          { value: 'choice', text: 'DAYS congés payés + RTT (nombre à définir)', rtt: 0 },
          { value: 'leader', text: 'Pas de congés payés (dirigeant)', rtt: 0 },
          { value: 'traineeship', text: 'Pas de congés payés (stage)', rtt: 0 },
      ]
  },

  get_time_modulation_choices() {
      return [
          { value: 'annual', text: 'Annualisation des horaires' },
          { value: 'semi_annual', text: 'Semestrialisation des horaires' },
          { value: 'quarter', text: 'Trimestrialisation des horaires' },
          { value: 'monthly', text: 'Mensualisation des horaires' },
          { value: 'daily', text: 'Forfait jours' },
      ]
  },

  get_working_time_choices() {
      return [
          { value: 'full_time', text: 'Temps plein' },
          { value: 'part_time', text: 'Temps partiel' },
      ]
  },

  get_timesheet_choices() {
      return [
          { value: 'attendance_days', text: 'Jours de travail' },
          { value: 'attendance_hours', text: 'Heures de travail' },
          { value: 'hours_by_project', text: 'Nombre d\'heure par projet' },
      ]
  },
  get_timesheet_validation_period_choices() {
      return [
          { value: 'month', text: 'Mois' },
          { value: 'week', text: 'Semaine' },
      ]
  },
}
const WorkingTimeModality = {...service('working-time-modalities')}
const WrittenAnswer = {...service('written-answers')}

module.exports = {
    Absence,
    AbsenceDocument,
    AbsenceType,
    Activity,
    Amount,
    AnnouncementComment,
    Announcement,
    Approval,
    CompanyGoodType,
    CompanyGood,
    Contract,
    Customer,
    DayWeek,
    Department,
    Dependant,
    EmployeeLanguage,
    EmployeeTask,
    Employee,
    Evaluation,
    EventComment,
    Event,
    ExpenseCategory,
    ExpenseReport,
    ExpenseTypeAdvance,
    ExpenseTypeBase,
    ExpenseTypeDiesel,
    ExpenseTypeDinnerRestaurant,
    ExpenseTypeFurniture,
    ExpenseTypeGasoline,
    ExpenseTypeHotel,
    ExpenseTypeLunchRestaurant,
    ExpenseTypeMileage,
    ExpenseTypeMiscellaneous,
    ExpenseTypeMobilePhone,
    ExpenseTypeParking,
    ExpenseTypePlane,
    ExpenseTypePublicTransportation,
    ExpenseTypeTaxi,
    ExpenseTypeToll,
    ExpenseTypeTrain,
    Expense,
    Expertise,
    ExportHistory,
    ExtraBenefit,
    FeedbackAnswer,
    FeedbackQuestion,
    FeedbackStep,
    Feedback,
    Flexibility,
    GraduatedAnswer,
    HolidayParam,
    HRDocument,
    HRNote,
    InterviewCampaign,
    InterviewComment,
    InterviewQuestion,
    InterviewStep,
    InterviewType,
    Interview,
    Language,
    MailTemplate,
    Objective,
    OnboardingArticle,
    OnboardingComment,
    OnboardingStep,
    OnboardingTask,
    Onboarding,
    OvertimeRuleWorkingSchedule,
    OvertimeRule,
    Participant,
    PayDetail,
    PayElement,
    PayRollBatch,
    PayRoll,
    Position,
    PositionContract,
    ProfessionalPaymentMethod,
    Project,
    Provider,
    PublicHoliday,
    ReceiptDocument,
    RecurrenceRule,
    ScheduleField,
    ScheduleTemplateWorkingSchedule,
    ScheduleTemplate,
    Schedule,
    Session,
    TaskActor,
    TaxRate,
    Team,
    TimeSheet,
    TimeSheetConfig,
    TimeSheetDetail,
    TimeSheetPeriod,
    TimeSheetProject,
    TimeSheetProjectDetail,
    TimeSheetPeriodStatus,
    TrainingCourse,
    TrainingCoursePlan,
    VehicleFiscalHorsePower,
    Vehicle,
    WorkingSchedule,
    WorkingTimeModality,
    WrittenAnswer,
    ValidationRule,
    RentObject,
    AccountCard,
    EmployeeSession,
    TrainingCourseInterest
}
